export enum PlanFeatureType {
  IncludedUsageLimit = 'included-usage-limit',
  NotIncludedUsagePrice = 'not-included-usage-price',
  FeatureFlag = 'feature-flag',
  PolicyLimit = 'policy-limit',
}
